import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';
import Slider from 'rc-slider';

const slipSlider = (props) => {

	let label_left = 'Plaintiff';
	let label_right = 'Defendant';
	let colour_left = '#f55c34';
	let colour_right = '#2f8294';

	if(props.angle === 'defendant') {
		label_left = 'Defendant';
		label_right = 'Plaintiff';
		colour_left = '#2f8294';
		colour_right = '#f55c34';
	}

	let slider_lock_overlay = null;
	if(props.halflock)
		slider_lock_overlay = <div className='rc-slider-track rc-slider-lock'></div>;

	return (
		<div className='slipslider'>
			<div className='slipslider__side slipslider__side--left'>
				<label>{label_left}<span className='slipslider__side__pcnt'> (%)</span></label>
				<span className='percent'><input type='number' value={+props.data} onChange={
						(event) => {props.rdxEditValue(props.id,event.target.value,props.halflock)}} /></span>
			</div>
			<div className='slipslider__side slipslider__side--right'>
				<span className='percent'><input type='number' value={100 - +props.data} onChange={
						(event) => {props.rdxEditValue(props.id,100 - +event.target.value,props.halflock)}} /></span>
				<label>{label_right}<span className='slipslider__side__pcnt'> (%)</span></label>
			</div>
			<div className={'slipslider__middle slipslider--angle-' + props.angle}>
				<Slider
					value={+props.data}
					trackStyle={{ backgroundColor: colour_left, height: 15 }}
					handleStyle={{
						borderColor: colour_left,
						height: 48,
						width: 48,
						marginLeft: -24,
						marginTop: -17,
						backgroundColor: '#cac2b0',
					}}
					railStyle={{ backgroundColor: colour_right, height: 15 }}
					onChange={(v) => {props.rdxEditValue(props.id,v,props.halflock)}}
				>{slider_lock_overlay}</Slider>
				<div className='slipslider__overlay'>
					<div className='slipslider__overlay__inner'>
						<span className='slipslider__overlay__icon' style={{left: props.data+'%'}}>
							<i className='fas fa-sort'></i>
						</span>
					</div>
				</div>
			</div>
		</div>
	);

}

const mapDispatchToProps = dispatch => {
	return {
		rdxEditValue: (id,value,halflock) => {
			if(halflock)
				if(value < 51) value = 51;
			dispatch(actions.editValue(id,value))
		}
	};
}

export default connect(null, mapDispatchToProps)(slipSlider);


// WEBPACK FOOTER //
// ./src/UI/SlipSlider.js